import React from 'react';
import { Container } from '@/components/ui/Container';
import { DetailScreenTitle } from '@/pages/inside/tenant/style';
import ProjectSettingsForm from '@/components/module/projects/settings_tab/ProjectSettingsForm';

export default function ProjectSettingsTab({ projectId }) {
    return (
        <Container $padding="0 24px 24px 0" $width="100%">
            <DetailScreenTitle>Project Settings</DetailScreenTitle>
            <ProjectSettingsForm projectId={projectId} />
        </Container>
    );
}
